export default () => {
  const parseCash = (cash, currency, sign) => {
    return ((cash / 100).toFixed(2) + (sign || currency)).replace('.', ',');
  };

  return { parseCash };
};
